import _defineProperty from "/usr/app/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import React from "react";
var __jsx = React.createElement;
import { Link } from "react-router-dom";
import { CDN_LINK } from "@globalConfig";
import stl from "./LinksToSearchV2.module.css";
import { useTranslation } from "@i18n";
import ProgressiveImage from "@componentsShared/ProgressiveImage";
import useHelpers from "@hooks/useHelpers";
var createLinkRaw = function createLinkRaw(props, _createUrl) {
  return function (item) {
    var _item$from, _item$to;
    if (props.isPrice) return "".concat(_createUrl("/filters", _defineProperty(_defineProperty({}, "sellingprice_from", item.from), "sellingprice_to", item.to), {
      referral_location: "Home",
      browse_variant: props.isPrice ? "price" : "mileage",
      variant_value: "from ".concat(item.from, " to ").concat(item.to)
    }));
    return "".concat(_createUrl("/filters", {
      // condition_id: props.isNew ? 1 : 0,
      odometer_from: item === null || item === void 0 ? void 0 : (_item$from = item.from) === null || _item$from === void 0 ? void 0 : _item$from.replace(",", ""),
      odometer_to: (_item$to = item.to) === null || _item$to === void 0 ? void 0 : _item$to.replace(",", "")
    }, {
      referral_location: "Home",
      browse_variant: props.isPrice ? "price" : "mileage",
      variant_value: "from ".concat(item.from, " to ").concat(item.to)
    }));
  };
};
function LinksToSearchV2(props) {
  var _props$data;
  var _useTranslation = useTranslation(["web_home"]),
    t = _useTranslation.t;
  var _useHelpers = useHelpers(),
    createUrl = _useHelpers.createUrl;
  var createLink = createLinkRaw(props, createUrl);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: stl.container
  }, props === null || props === void 0 ? void 0 : (_props$data = props.data) === null || _props$data === void 0 ? void 0 : _props$data.map(function (item, idx) {
    return /*#__PURE__*/React.createElement(Link, {
      style: {
        backgroundColor: props.bgColor
      },
      key: "link" + idx,
      to: createLink(item)
    }, "".concat(item.text ? item.text : "", " ").concat(item[props.fieldName], " ").concat(item.unit));
  }), /*#__PURE__*/React.createElement(Link, {
    to: props.moreLink,
    className: stl.moreLink
  }, /*#__PURE__*/React.createElement("span", null, t("view", {
    ns: "web_home"
  })), /*#__PURE__*/React.createElement(ProgressiveImage, {
    waitUntilInteractive: true,
    src: CDN_LINK + "/assets/images/arrMore.png",
    fetchpriority: "low",
    alt: "",
    width: 15,
    height: 19
  }))));
}
export default LinksToSearchV2;